import * as React from "react";
import { FormattedMessage } from "react-intl";
import { HooplaUser, NavigationLink } from "types";
import User from "components/User";
import Tabs from "components/Tabs";
import Menu from "components/Menu";
import * as styles from "./styles";
import logout from "../../helpers/logout";
import { colors } from "styles/styles";
import { GlobeIcon } from "assets/icons/globe";
import { TicketWhiteIcon } from "assets/icons/ticket-white";
import { LangContext } from "index";
import logo from "assets/logo-black-new.svg";
import { getDomain } from "helpers/getDomain";

interface IProps {
  user?: HooplaUser;
}

export const links: NavigationLink[] = [
  {
    to: "/",
    text: <FormattedMessage id="navigation.tickets" />,
    position: "left",
    exactMatch: true,
  },
  {
    to: "/privacy",
    text: <FormattedMessage id="navigation.consents" />,
    position: "left",
  },
  // { // Hide this tab until the receipts feature is complete
  //   to: '/receipts',
  //   text: <FormattedMessage id="navigation.purchases" />,
  //   position: 'left',
  // },
  {
    to: "/settings",
    text: <FormattedMessage id="navigation.settings" />,
    position: "right",
  },
];

const Header: React.FC<IProps> = ({ user }) => {
  const { lang, setLang } = React.useContext(LangContext);
  return (
    <React.Fragment>
      <div className={styles.topbar}>
        <div className={styles.logoWrapper}>
          <a href={`https://www.${getDomain()}`} style={{ display: "inline-flex" }}>
            <img className={styles.logo} src={logo} alt="Logo" />
          </a>
        </div>
        {process.env.REACT_APP_REGION === "NO" && (
          <div className={styles.link} onClick={() => setLang(lang === "en" ? "nb" : "en")}>
            <GlobeIcon color={colors["grey_20"]} size={18} />
            <div style={{ marginLeft: "0.5rem" }}>{lang === "en" ? "Norsk" : "English"}</div>
          </div>
        )}
        {user && (
          <div className={styles.link} onClick={logout}>
            <TicketWhiteIcon color={colors["grey_20"]} size={18} />
            <div style={{ marginLeft: "0.5rem" }}>
              <FormattedMessage id="components.Header.logout" />
            </div>
          </div>
        )}
        <Menu links={links} />
      </div>
      <div className={styles.container}>
        {user && (
          <React.Fragment>
            <User email={user.email} firstName={user.firstName} lastName={user.lastName} />
            <Tabs links={links} />
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default Header;
